export default "__VITE_ASSET__1VOVRSQC__"